import { Send } from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  InputAdornment,
  Stack,
  TextField,
} from "@mui/material";
import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext, PosizionamentoContext } from "../contexts";
import { useForm } from "../hooks";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { TableRowHtml } from "../components";
import { green } from "@mui/material/colors";
//03/12/2025 Greg: per prisma: registrando sscc si ubica la paletta completa, regisntrando seriale si registra il singolo articolo
import { getModalitaMenuCustom, Modalita_SSCCSeriale, confermaNumeroColliActive } from "../utilities";
import { set } from "date-fns";
import { te } from "date-fns/locale";

const MagLogCustomDettaglio = (props) => {
  const navigate                                                = useNavigate();
  const { codiceMenu, prgMovimento }                            = useParams();
  const [customCol, setCustomCol]                               = React.useState([]);
  const [numeroColliDialogOpen, setNumeroColliDialogOpen]       = React.useState(false);
  const [numeroColliDaConfermare, setNumeroColliDaConfermare]   = React.useState(0);
  const [loadingConfermaMovimento, setLoadingConfermaMovimento] = React.useState(false);
  const inputRef                                                = React.useRef();

  const {
    state: { MovimentoColumns, movimento, infoMovimento },
    getMagMovimDataCustom,
    postRegistraMovimentoCustom,
    postConfermaMovimentoCustom,
    postRegistraMovimentoCustomSSCC,
  } = useContext(PosizionamentoContext);

  const {
    state: { visibleMenu },
  } = useContext(AuthContext);

    useEffect(() => {
      if (prgMovimento) {
        
        getMagMovimDataCustom(codiceMenu, prgMovimento,  navigate);
      }
    }, []);
  
  const validations = [];
  const {
    values: articoloForm,
    changeHandler,
    setValues,
    errors,
    touched,
    isValid,
  } = useForm(
    {
      CodiceArticolo: "",
      Articolo: "",
      Ubicazione: "",
    },
    validations
  );



 
    React.useEffect(() => {
      let colonneDaModificare = [];
      if (MovimentoColumns){
        MovimentoColumns.map((res, i) => {
          colonneDaModificare = [
            ...colonneDaModificare,
            {
              field: res.id,
              headerName: res.label,
              minWidth: res.minWidth,
            },
          ];
        });
        setCustomCol(colonneDaModificare);
      }
    }, [MovimentoColumns]);
  
  const onkeyEnter = (event, modalita) => {
    if (event === 13) {
      saveData(modalita);
    }
  };
  
    const saveData = (modalita) => {  
      if ( confermaNumeroColliActive ){
        setNumeroColliDialogOpen(true);
      }
      else {
        if (modalita === Modalita_SSCCSeriale) {
          postRegistraMovimentoCustomSSCC(codiceMenu, prgMovimento, articoloForm);
        } else {
          postRegistraMovimentoCustom(codiceMenu, prgMovimento, articoloForm);
        }
        clearForm();
      }
      
      // setTimeout(() => {
      //   inputRef.current.focus();
      // }, 100);      
    }



  const clearForm = () => {    
    setValues({
      CodiceArticolo : "",
      Articolo       : "",
      Ubicazione     : "",
    });
  }
  

  const confermaMovimentoActive = () => {
    let confermaMovimentoActive = false;
    visibleMenu.forEach((element) => {
      if ( element.codiceMenu === codiceMenu ){
        if (element.confermaNumeroColliActive === true) {
          confermaNumeroColliActive = true;
        };
      };
    });
    return (confermaMovimentoActive);
  }

  const closeNumeroColliDialog = () =>{
    setNumeroColliDialogOpen(false);
    clearForm();
  }

  //15/12/2025 Greg: calcola il numero di colli da confermare per popup conferma numero colli
  // supponto ordinamento per nriga asc. attualmente irs ordina così. in caso cambiasse
  // è da cambiare anche qui la logica di ordinamento
  const CalcolaNumeroColliDaConfermare = () => {
    let numeroColli = 0;
    let minNRiga = -1
    if ( articoloForm.Ubicazione !== "" && numeroColliDialogOpen === true ) {
;
      movimento.forEach((element) => {
        //Selezionare il record
      
        if (element.Ubicazione === articoloForm.Ubicazione ){
          if (element.StatoRiga !== 'OK') {
            if ( minNRiga === -1 ) {
                minNRiga = element.NRiga;
                numeroColli = element.Colli;
              }
              else {
                if ( element.NRiga < minNRiga ){
                  minNRiga = element.NRiga;
                  numeroColli = element.Colli;
                }
              }
            }; 
        }
  
      });      
    }
    return numeroColli;
  }

  const textForNumeroColliDialog = () => {
    if ( numeroColliDaConfermare > 1 ){
      return `Confermi prelievo di ${numeroColliDaConfermare} colli?`;
    }
    else if (numeroColliDaConfermare > 0) {
      return `Confermi prelievo di ${numeroColliDaConfermare} collo?`;
    }
    return `Nessun collo da confermare.`;
  }

  // Keep numeroColliConfermaVisible in sync when the dialog opens or inputs change
  React.useEffect(() => {
    setNumeroColliDaConfermare(CalcolaNumeroColliDaConfermare());
  }, [numeroColliDialogOpen, movimento, articoloForm?.Ubicazione]);


  const onConfermaNumeroColli = () => {
    postRegistraMovimentoCustom(codiceMenu, prgMovimento, articoloForm);
    closeNumeroColliDialog();
  }

  const getTextFieldEntitabyModalita = () => {
    let modalitaMenu = getModalitaMenuCustom(codiceMenu, visibleMenu);
    if (modalitaMenu === Modalita_SSCCSeriale) {
      return (
        <Stack spacing={4} sx={{ width: "100%" }} alignItems="stretch">
          <TextField
            id="outlined-basic"
            label="Barcode"
            variant="outlined"
            placeholder="Inserire il barcode"
            fullWidth
            autoFocus
            autoComplete="off"
            inputRef={inputRef}
            onKeyPress={(e) => onkeyEnter(e.charCode, modalitaMenu)}
            onChange={(e) => changeHandler("CodiceArticolo", e.target.value)}
            error={Boolean(touched.code && errors.code)}
            value={articoloForm.CodiceArticolo || ""}

          />

          {/* <TextField
            id="outlined-basic"
            label="Ubicazione"
            variant="outlined"
            placeholder="Inserire l'ubicazione"
            fullWidth
            autoFocus
            autoComplete="off"
            inputRef={inputRef}
            onChange={(e) => changeHandler("Ubicazione", e.target.value)}
            value={articoloForm.Ubicazione || ""}
            onKeyPress={(e) => onkeyEnter(e.charCode)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    color="primary"
                    disabled={!isValid}
                    onClick={() => onkeyEnter(13, modalitaMenu)}
                  >
                    <Send />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          /> */}
      </Stack>
      )
    }
    //default
    else {
      return (
        <TextField
          id="outlined-basic"
          label="Barcode"
          variant="outlined"
          placeholder="Inserire il barcode"
          fullWidth
          autoFocus
          autoComplete="off"
          inputRef={inputRef}
          onChange={(e) => changeHandler("Ubicazione", e.target.value)}
          value={articoloForm.Ubicazione || ""}
          onKeyPress={(e) => onkeyEnter(e.charCode, modalitaMenu)}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  variant="contained"
                  color="secondary"
                  onClick={() => onkeyEnter(13, modalitaMenu)}
                >
                  <Send />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      );
    }
  };

  return (
    <Grid container>
      <Grid
        container
        sx={{
          position: "fixed",
          background: (theme) => theme.palette.background.paper,
        }}
      >
        {getTextFieldEntitabyModalita()}
      </Grid>

      <Grid container mt={8} spacing={2}>
        <Grid item xs={12} md={6} lg={6}>
          <Alert severity="info" component="span">
            {
              <ReactMarkdown
                children={infoMovimento !== "" ? infoMovimento : " "}
                rehypePlugins={[rehypeRaw]}
              ></ReactMarkdown>
            }{" "}
          </Alert>
          <Alert severity="warning" component="span">
            {
              <ReactMarkdown
                children={
                  infoMovimento?.summarytext
                    ? infoMovimento.summarytext.toString()
                    : " "
                }
                rehypePlugins={[rehypeRaw]}
              ></ReactMarkdown>
            }
          </Alert>
          <Grid item xs={12} md={12} lg={12}>
            {customCol?.length > 0 ? (
              <TableRowHtml customCol={customCol} rows={movimento} />
            ) : (
              <></>
            )}
          </Grid>
        </Grid>
      </Grid>
      {confermaMovimentoActive() === true ? (
        <Box sx={{ position: "relative" }}>
          <Button
            onClick={() => {
              postConfermaMovimentoCustom(
                codiceMenu,
                prgMovimento,
                navigate,
                setLoadingConfermaMovimento
              );
            }}
            variant="contained"
            sx={{ ml: 1, mt: 1 }}
            disabled={loadingConfermaMovimento}
          >
            Conferma movimento
          </Button>

          {loadingConfermaMovimento && (
            <CircularProgress
              size={24}
              sx={{
                color: green[500],
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-12px",
                marginLeft: "-12px",
              }}
            />
          )}
        </Box>
      ) : (
        <></>
      )}

    <div>
      <Dialog
        open = { numeroColliDialogOpen }
        onClose = {closeNumeroColliDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          { "Conferma prelievo colli" }
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {textForNumeroColliDialog()}
              
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeNumeroColliDialog}>Esci</Button>           
          <Button onClick={onConfermaNumeroColli} disabled={ numeroColliDaConfermare <= 0 } >
            Conferma
          </Button>
        </DialogActions>
      </Dialog>
    </div>


      </Grid>
    );
  };
  
  export default MagLogCustomDettaglio;
  
